// import * as util from '../apiUtils';
// import * as common from '../apiCommon';
// import * as DocType from '../../constants/constant_doc_types';

export async function fetchSummaryTypeData(app, type, filters) {
  const service = app.service('store-summary');
  const data = await service.get(type, { filters });
  return data;
}

export async function exportSummaryService(app, type, filters, requestType) {
  const service = app.service('store-summary/export');
  const data = await service.get(type, { filters, requestType });

  return data;
}